import { GPTGameNameType } from '../../types';
import { DailyBonusIcon } from '../../../icons/DailyBonusIcon';
import { LuckyCardIcon } from '../../../icons/LuckyCardIcon';
import { LuckyPigeonIcon } from '../../../icons/LuckyPigeonIcon';
import { WheelOfFortuneIcon } from '../../../icons/WheelOfFortuneIcon';
import { GPTGameIcon, VendingMachineIcon } from '../../../icons';

export const GPT_BUTTONS_CONFIG: Record<GPTGameNameType, { Icon: GPTGameIcon; title: string }> = {
  dailyBonus: {
    Icon: DailyBonusIcon,
    title: 'gpt.dailyBonusTitle'
  },
  cardGame: {
    Icon: LuckyCardIcon,
    title: 'gpt.luckyCardTitle'
  },
  birdGame: {
    Icon: LuckyPigeonIcon,
    title: 'gpt.luckyPigeonTitle'
  },
  oneReelSlot: {
    Icon: () => <></>,
    title: 'gpt.oneReelSlotTitle'
  },
  wheelOfFortune: {
    Icon: WheelOfFortuneIcon,
    title: 'gpt.wheelOfFortuneTitle'
  },
  vendingMachine: {
    Icon: VendingMachineIcon,
    title: 'gpt.vendingMachineTitle'
  }
};
